module.exports = __webpack_public_path__ + "static/media/circle_crane_icon.9debc26c.svg";